export const SakModuleName = 'sak';
export const SwedishSakModuleName = 'dedusak';
export const StatusModuleName = 'status';
export const CountModuleName = 'count';
